import type { SkiAreaBeyondSlopes } from '@/cms/fields/mappers/destinationPageFieldsMapper'
import { useIntl } from '@/intl'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { InfoCard } from '../InfoCard/InfoCard'
import styles from './BeyondSlopes.module.css'

interface BeyondSlopesProps {
  data: SkiAreaBeyondSlopes
}

export function BeyondSlopes({ data }: BeyondSlopesProps) {
  const intl = useIntl()
  const items = [
    { glyph: 'MountainsWithArrowUp', label: intl.formatMessage({ id: 'destination_ski_area_beyond_slope_height' }), value: `${data.heightRange.min}m - ${data.heightRange.max}m` },
    { glyph: 'PersonCrossCountrySkiing', label: intl.formatMessage({ id: 'destination_ski_area_beyond_slope_cross_country' }), value: `${data.nordicKm} km` },
    { glyph: 'MountainsGlacier', label: intl.formatMessage({ id: 'destination_ski_area_beyond_slope_glacier' }), value: String(data.glaciers) },
    { glyph: 'PersonOnSnowboardInRamp', label: intl.formatMessage({ id: 'destination_ski_area_beyond_slope_fun_park' }), value: String(data.funParks) },
  ]

  return (
    <InfoCard title={intl.formatMessage({ id: 'destination_ski_area_beyond_slope_title' })} titleId="beyond-slopes-title">
      <div className={styles.grid}>
        {items.map(({ glyph, label, value }) => (
          <div key={label} className={styles.factItem}>
            <Icon glyph={glyph as IconGlyph} size={32} aria-hidden="true" />
            <Typography variant="display-j-regular">
              {value}
            </Typography>
            <Typography variant="body-s-regular-tight" className={styles.factLabel}>{label}</Typography>
          </div>
        ))}
      </div>
    </InfoCard>
  )
}
